export const APP_CONFIGURATION_REQUEST = 'APP_CONFIGURATION_REQUEST';
export const APP_CONFIGURATION_SUCCESS = 'APP_CONFIGURATION_SUCCESS';
export const APP_CONFIGURATION_FAILURE = 'APP_CONFIGURATION_FAILURE';
export const APP_CONFIGURATION_SET_USER_CONFIGURATION = 'APP_CONFIGURATION_SET_USER_CONFIGURATION';
